import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function StaffPrivateComponent() {
  const auth = localStorage.getItem("f&gstafftoken");

  return <div>{auth ? <Outlet /> : <Navigate to="/panel/office/login" />}</div>;
}
